/* eslint-disable react/prop-types */
import * as React from 'react';
import { useEffect, useState } from 'react';
import ReceiptPage from './ReceiptPage';
import { isProduction } from '../fastflowUtils';
import {
  classNames,
  FontWeight,
  Loader,
  Padding,
  TextAlign,
  TextColor,
} from '@snoam/pinata';
import { parse } from 'query-string';

const styleClass = {
  container: classNames(
    TextAlign.TEXT_CENTER,
    FontWeight.FONT_LIGHT,
    Padding.PT_4,
    TextColor.TEXT_NEUTRAL_7,
    Padding.MD_PT_12,
  ),
};

const ReceiptWrapper = (props) => {
  const [receiptPageData, setReceiptPageData] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const callSps = async (productId) => {
    const spsBaseUrl = isProduction()
      ? 'https://cm.schibsted.tech'
      : 'https://sps-api.pre.ma.schibsted.digital';
    await fetch(`${spsBaseUrl}/wp-json/cm/v1/aftenposten/receipt/${productId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          setReceiptPageData(data.data.poster.html);
        }
        setLoading(false);
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((e) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    if (
      props &&
      props.location?.pathname.includes('/receipt') &&
      props.productInfo.productId
    ) {
      callSps(props.productInfo.productId);
    }
  }, [props.location.pathname, props.productInfo.productId]);

  if (loading) {
    return (
      <div className={styleClass.container}>
        <Loader />
      </div>
    );
  }

  const duplicate = parse(props.location?.search).duplicate === 'true';

  if (receiptPageData && !duplicate) {
    return <ReceiptPage {...props} vevContent={receiptPageData} />;
  }
  return props.children;
};

export default ReceiptWrapper;
